/**
 * 支付流程共3个接口
 * - 创建预支付订单 /merchantTrade/preOrder 这个接口没有使用上
 * - 查询预订单 /clientTrade/queryPreOrder
 * - 支付密码支付 /clientTrade/v2/payPreOrderPwd
 *
 * - VM渠道支付 3ds认证 初始化认证 /clientTrade/authentication
 * - 查询支付结果 /clientTrade/queryPayOrderResult
 * - 获取短信验证码(支付超过限额时使用) /clientTrade/getPaySmsCode
 */
import fetch from '@/utils/fetch/index'

export interface ClientOrderParams {
  /** 授权token 预留使用 */
  appAuthToken?: string
  /** 澳觅分配的应用id 可以不传 */
  appId?: number
  /** 业务内容 json格式 bizContent => orderParamStr */
  bizContent: string
  /** 支付类型。默认澳觅支付 */
  payType?: string
  /** 签名 */
  sign?: string
  /**
   * 签名，将除sign字段外，所有请求参数
   * 按字母升序排序，参数之间使用&拼接(eg. appId=12a&signType=RSA2……)，
   * 拼接成字符串，使用指定的signType 进行签名
   *
   * 文档上是必填 实际好像不需要
   */
  signType?: string
  /**
   * 时间戳 yyyy-MM-dd HH:mm:ss
   *
   * 文档上是必填 实际好像不需要
   */
  timestamp?: string
}

export interface PayPreOrderPwdParams {
  /** 银行编码，02：大丰、03：澳门国际、04：银联无感、05：BNU、06：VM */
  bankNo?: string
  /** 卡id | 长度为48数字字母 */
  cardId: string
  /** 折扣金额 */
  discount: string
  /** 优惠活动id | 长度不大于48 */
  discountActId: string
  /** 折扣类型 | 长度为不大于2 */
  discountType: string
  /** 支付密码 | 长度为32 */
  password: string
  /** 短信验证码 */
  smsCode?: string
  /** 支付流水号 | 长度不大于48 */
  tradeNo: string
}

/**
 * 根据通过桥接方法拿到的预订单参数 生成+查询预订单信息
 * @param
 * @returns 卡列表信息和预定单信息
 */
export function genOrder(params: ClientOrderParams) {
  return fetch('/clientTrade/v1/genOrder', {
    params,
  })
}

/**
 * 根据订单号直接查询预订单信息
 * @param tradeNo - 交易流水号
 * @returns 卡列表信息和预定单信息
 */
export function queryPreOrderByTradeNo(tradeNo: string) {
  return fetch('/clientTrade/queryPreOrder', {
    params: {
      tradeNo,
    },
  })
}

/**
 * 支付密码支付
 * @param params
 * @returns
 */
export function payPreOrderPwd(params: PayPreOrderPwdParams) {
  return fetch('/clientTrade/v2/payPreOrderPwd', {
    params,
    isToastErr: false,
  })
}

/**
 * VM渠道支付 3ds认证 初始化认证
 * @param params
 * @returns
 */
export function vmPay3DSAuthentication(params) {
  return fetch('/clientTrade/authentication', {
    params,
  })
}

/**
 * 查询支付结果
 * @param tradeNo
 * @returns
 */
export function queryPayOrderResult(params) {
  return fetch('/clientTrade/queryPayOrderResult', {
    params,
  })
}

/**
 * 获取短信验证码
 * @param {*} params
 */
export function getPaySmsCode(params) {
  return fetch('/clientTrade/getPaySmsCode', {
    params,
  })
}

/**
 * 获取第一张卡的手机号
 */
export function getFirstCardPhone() {
  return fetch('/customer/getFirstCardPhone')
}
